<!-- =========================================================================================
    File Name: ServerMonitoringEmail.vue
    Description: ServerMonitoringEmail Page
========================================================================================== -->

<template>
  <div>
    <notice-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
    <p class="text-danger font-bold mb-5"> 
      <feather-icon icon="HashIcon" svgClasses="w-5 h-5" class="edit-icon text-danger font-bold mb-5" />
      {{this.$t('NOTICE_MESSAGE')}}
    </p>
    <vx-card class="overflow-auto">
        <vs-button v-if="onlyAdmin" icon-pack="feather" icon="icon-plus" @click="addNewData">{{$t('ADD_NOTICE')}}</vs-button>
        <v-server-table id="notice-table" ref="noticeTable" name="noticeTables"
            :columns="getColumn" :options="options" @loading="onLoading" @loaded="onLoaded">
          <vs-button slot="noticeBody" slot-scope="props" color="primary" type="flat" @click="noticeBodyPopup(props.row)"  class="w-full">
           {{$t('SHOW_NOTICE_BODY')}}</vs-button>  
          <vs-chip slot="popUp" slot-scope="props" :color="getPopUpColor(props.row.popUp)" class="w-full">
            {{$t(setPopUpName(props.row.popUp))}}</vs-chip>
          <div slot="edit" slot-scope="props">
             <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(props.row)" />
          </div>
        </v-server-table>
    </vx-card>

    <vs-popup class="notice-body-popup"  :title="this.noticeTitle" :active.sync="noticePopupActive">
        <span v-html="this.noticeBody.replace(/(?:\r\n|\r|\n)/g, '<br />')"></span>
        <br/>
      </vs-popup>
  </div>
</template>

<script>
window.axios = require('axios');
var sanitizeHtml = require('sanitize-html');


import NoticeSidebar from "./NoticeSidebar.vue"
import moduleSystem from "@/store/system/moduleSystem.js"

export default {
  components: {
    NoticeSidebar
  },
  data() {
    return {
      noticeBody: "",
      noticeTitle: "",
      noticePopupActive: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      // Table
      columns: ['seq', 'popUp', 'noticeTitle', 'noticeBody', 'createdBy', 'modifiedBy', 'createdDateTime', 'modifiedDateTime', 'edit'],
      userColumns:  ['seq', 'popUp', 'noticeTitle', 'noticeBody', 'createdBy', 'modifiedBy', 'createdDateTime', 'modifiedDateTime'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['popUp', 'noticeTitle', 'createdBy', 'modifiedBy', 'createdDateTime', 'modifiedDateTime'],
        sortable: ['popUp', 'noticeTitle', 'createdBy', 'modifiedBy', 'createdDateTime', 'modifiedDateTime'],
        orderBy: { ascending: false },
        debounce: 1000,
        dateColumns:['createdDateTime', 'modifiedDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true
        },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
            filterBy: this.$t("FILTER_BY"),
            defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'seq': () => this.$t("SEQ"),
          'popUp': () => this.$t("POP_UP"),
          'noticeTitle': () => this.$t("NOTICE_TITLE"),
          'noticeBody': () => this.$t("NOTICE_BODY"),
          'createdBy': () => this.$t("CREATED_BY"),
          'modifiedBy': () => this.$t("MODIFIED_BY"),
          'createdDateTime': () => this.$t("CREATED_DATE_TIME"),
          'modifiedDateTime': () => this.$t("MODIFIED_DATE_TIME"), 
          'edit': () => this.$t("EDIT")
        },
        listColumns:{
          popUp:[
            {
              id: 'Y',
              text: this.$t("POPUP_Y")
            },
            {
              id: 'N',
              text: this.$t("POPUP_N")
            },
          ],
        },
        rowClassCallback: function(row){
    	    return row.popUp === "Y"? 'popupY': '';
        },
        requestAdapter: function(data) {

          if(data.query.createdDateTime){
            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let queryStart = moment.tz(data.query.createdDateTime.start, localTimeZone).format()
            let queryEnd = moment.tz(data.query.createdDateTime.end, localTimeZone).format()

            let start = moment(queryStart).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(queryEnd).utc().format('YYYY-MM-DD HH:mm:ss')
                            
            data.query.createdDateTime.start = start
            data.query.createdDateTime.end = end
          }

          if(data.query.modifiedDateTime){
            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let queryStart = moment.tz(data.query.modifiedDateTime.start, localTimeZone).format()
            let queryEnd = moment.tz(data.query.modifiedDateTime.end, localTimeZone).format()

            let start = moment(queryStart).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(queryEnd).utc().format('YYYY-MM-DD HH:mm:ss')
                            
            data.query.modifiedDateTime.start = start
            data.query.modifiedDateTime.end = end
          }
          
          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "seq",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        requestFunction: function (data) {
          return this.$http.get('/api/notice-management/notices', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataSystem/SET_NOTICE',response.data)
          return {
            data: this.$store.state.dataSystem.notice,
            count: this.$store.state.dataSystem.noticeCount
          }
        },
        templates:{
          createdDateTime: function(h,row){
            let createdDateTime = row.createdDateTime
            if(!createdDateTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(createdDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
                            
              return dateTimeToLocal
            }
          },
          modifiedDateTime: function(h,row){
            let modifiedDateTime = row.modifiedDateTime
            if(!modifiedDateTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(modifiedDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
                            
              return dateTimeToLocal
            }
          },
        }
      }
    }
  },
  created() {
    if (!moduleSystem.isRegistered) {
      this.$store.registerModule('dataSystem', moduleSystem)
      moduleSystem.isRegistered = true
    }
  },
  computed:{
    onlyAdmin() {
      return this.$store.state.AppActiveUser.userRole === 'admin' ? this.$acl.check(this.$store.state.AppActiveUser.userRole) : false
    },
    getColumn(){
      if(this.$store.state.AppActiveUser.userRole === 'admin'){
        return this.columns
      }else{
        return this.userColumns
      }
    }
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getPopUpColor(popup) {
      if(popup === "Y"){
          return "success"
      }else{
          return "danger"
      }
    },
    setPopUpName(popup){
       if(popup === "Y"){
          return this.$t("POPUP_Y")
        }else{
          return this.$t("POPUP_N")
        }
    },
    noticeBodyPopup(data){
      this.noticePopupActive = true;
      this.noticeTitle = sanitizeHtml(data.noticeTitle)
      this.noticeBody = sanitizeHtml(data.noticeBody)
    },
  },
}

</script>

<style lang="scss">
#notice-table{
  text-align:center;
}

.popupY {
  background:#EFEDFD;
  font-weight: bold;
}
</style>